import React from "react";
import "../styles/Weather.css";

function WeatherCard({ name, image, forcastWeather }) {
  return (
    <div className="card border border-primary" style={{ width: "18rem" }}>
      <img className="card-img-top weatherIcon" src={image} alt="weather" />
      <div className="card-body text-white bg-primary">
        <h5 className="card-title ">{name}</h5>
        <p className="card-text">{forcastWeather}</p>
      </div>
    </div>
  );
}

export default WeatherCard;
